import { useEffect, useState } from 'react'
import { ProjectNanoIdSchema } from '@composio/types'

const specificKeys = {
  'current.project': ProjectNanoIdSchema,
}

type SpecificKeys = keyof typeof specificKeys

type Output<T extends SpecificKeys> = ReturnType<
  (typeof specificKeys)[T]['parse']
>

export const useLocalStorage = () => {
  const [windowActive, setWindowActive] = useState(false)

  useEffect(() => {
    setWindowActive(true)

    return () => {
      setWindowActive(false)
    }
  }, [])

  const setItem = (key: string, value: string) => {
    if (windowActive) {
      localStorage.setItem(key, value)
    }
  }

  const getItemSpecific = <T extends SpecificKeys>(
    key: T,
  ): Output<T> | undefined => {
    if (windowActive) {
      const value = localStorage.getItem(key)

      if (!specificKeys[key]) {
        return undefined
      }

      return specificKeys[key].safeParse(value).data as Output<T>
    }
  }

  const getItemGeneric = (key: string) => {
    if (windowActive) {
      return localStorage.getItem(key)
    }
  }

  return {
    setItem,
    getItemGeneric,
    getItemSpecific,
  }
}
